export default "__VITE_ASSET__c29d80fe__"